module.exports = __webpack_public_path__ + "static/img/ai.7e4ee030.svg";